import { SYSTEM } from '../internal/environment';
import customCssProps from '../internal/generated/custom-css-properties';
export function getTokenRootStyles(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (SYSTEM !== 'core') {
        return {};
    }
    return {
        borderRadius: (_a = style === null || style === void 0 ? void 0 : style.root) === null || _a === void 0 ? void 0 : _a.borderRadius,
        borderWidth: (_b = style === null || style === void 0 ? void 0 : style.root) === null || _b === void 0 ? void 0 : _b.borderWidth,
        paddingBlock: (_c = style === null || style === void 0 ? void 0 : style.root) === null || _c === void 0 ? void 0 : _c.paddingBlock,
        paddingInline: (_d = style === null || style === void 0 ? void 0 : style.root) === null || _d === void 0 ? void 0 : _d.paddingInline,
        [customCssProps.tokenStyleBackgroundDefault]: (_f = (_e = style === null || style === void 0 ? void 0 : style.root) === null || _e === void 0 ? void 0 : _e.background) === null || _f === void 0 ? void 0 : _f.default,
        [customCssProps.tokenStyleBackgroundDisabled]: (_h = (_g = style === null || style === void 0 ? void 0 : style.root) === null || _g === void 0 ? void 0 : _g.background) === null || _h === void 0 ? void 0 : _h.disabled,
        [customCssProps.tokenStyleBackgroundReadOnly]: (_k = (_j = style === null || style === void 0 ? void 0 : style.root) === null || _j === void 0 ? void 0 : _j.background) === null || _k === void 0 ? void 0 : _k.readOnly,
        [customCssProps.tokenStyleBorderColorDefault]: (_m = (_l = style === null || style === void 0 ? void 0 : style.root) === null || _l === void 0 ? void 0 : _l.borderColor) === null || _m === void 0 ? void 0 : _m.default,
        [customCssProps.tokenStyleBorderColorDisabled]: (_p = (_o = style === null || style === void 0 ? void 0 : style.root) === null || _o === void 0 ? void 0 : _o.borderColor) === null || _p === void 0 ? void 0 : _p.disabled,
        [customCssProps.tokenStyleBorderColorReadOnly]: (_r = (_q = style === null || style === void 0 ? void 0 : style.root) === null || _q === void 0 ? void 0 : _q.borderColor) === null || _r === void 0 ? void 0 : _r.readOnly,
    };
}
// Maps the token's dismiss button style to the button style. Button has no read-only state: a read-only token
// shows its dismiss button as disabled, and the disabled color wins when both apply. The token never had an
// active color, so pressing keeps the hover color.
export function getDismissButtonStyles(style, { disabled, readOnly }) {
    const dismissButton = style === null || style === void 0 ? void 0 : style.dismissButton;
    if (SYSTEM !== 'core' || !dismissButton) {
        return undefined;
    }
    const color = dismissButton.color;
    return {
        root: {
            color: color && {
                default: color.default,
                hover: color.hover,
                active: color.hover,
                disabled: readOnly && !disabled ? color.readOnly : color.disabled,
            },
            focusRing: dismissButton.focusRing,
        },
    };
}
//# sourceMappingURL=styles.js.map